// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2MQ0P","legacyBtn":"MutateMid_legacyBtn__1qphm"};